import styled from 'styled-components';
import { Platform, WriteDirection, DeviceType, Orientation } from 'sofa-reborn-react';

export const SuccessLightboxContent = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
}>`
	display: flex;
	flex-direction: column;
	padding: ${(props) => (props.platform === 'kiosk' ? '0 24px 24px' : '0 16px 16px')};
	max-width: ${(props) => (props.platform === 'kiosk' ? '950px' : '600px')};
	height: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape'
			? 'calc(100% - 55px)'
			: 'auto'};
	overflow: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape' ? 'auto' : 'hidden'};
`;

export const ErrorLightboxContent = styled.div<{
	writeDirection: WriteDirection;
}>`
	display: flex;
	max-width: 552px;
	padding: 72px 24px 16px;

	[data-element-name='kompis-icon'] {
		margin-right: ${(props) => props.writeDirection === 'ltr' && '16px'};
		margin-left: ${(props) => props.writeDirection === 'rtl' && '16px'};
		display: inline-block;
	}
`;

export const LoadingLightboxContent = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	[data-element-name='kompis-icon'] {
		animation: rotate 2s linear infinite;
	}
`;

export const StyledImage = styled.img`
	width: 100%;
`;

export const ImageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 200px;
`;

export const ConfigurationContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 16px 0;
`;

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const UserInfoContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 0 0 24px 0;
	align-items: center;
`;
